import api from '../../services/service_expend'
import Swal from 'sweetalert2'

export default {
  data () {
    return {
      exp_data: '',
      header: {
        headers: {
          'access-token': this.$store.state.token
        }
      }
    }
  },
  methods: {
    getExpenDetail () {
      this.$store.state.isLoading = true
      api.getExpen(
        this.$route.params.id,
        this.header,
        result => {
          if (result.response === true) {
            this.exp_data = result.data
            if (this.exp_data.length < 1) {
              this.$router.push('/manageexp')
            }
          } else {
            this.$router.push('/manageexp')
            Swal.fire('ดึงข้อมูลหมวดหมู่', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    printBill () {
      window.print()
    }
  },
  mounted () {
    this.getExpenDetail()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/expen_detail.js